import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

export type ConfirmDialogProps = {
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  /** Se true, o botão de confirmação usa estilo destrutivo (vermelho). Padrão: true */
  destructive?: boolean;
};

export default function ConfirmDialog({
  open,
  title = "Confirmar",
  message = "Confirmar atualização?",
  confirmLabel = "Sim",
  cancelLabel = "Não",
  onConfirm,
  onClose,
  destructive = true,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 24px 38px rgba(0,0,0,0.12), 0 12px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(0,0,0,0.4)",
          },
        },
      }}
    >
      <DialogContent sx={{ px: 3, pt: 3, pb: 2, "&.MuiDialogContent-root": { paddingTop: 3 } }}>
        <MDBox>
          <MDTypography
            variant="h6"
            fontWeight="bold"
            color="dark"
            sx={{ display: "block", mb: 1.5, lineHeight: 1.4 }}
          >
            {title}
          </MDTypography>
          <MDTypography
            variant="body2"
            color="text"
            sx={{ display: "block", lineHeight: 1.6 }}
          >
            {message}
          </MDTypography>
        </MDBox>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pt: 2,
          pb: 3,
          gap: 1.5,
          borderTop: 1,
          borderColor: "divider",
          bgcolor: "white",
        }}
      >
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={onClose}
          sx={{ textTransform: "none", fontWeight: 600, px: 2.5 }}
        >
          {cancelLabel}
        </MDButton>
        <MDButton
          variant={destructive ? "contained" : "gradient"}
          color={destructive ? "error" : "dark"}
          onClick={onConfirm}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            ...(destructive && {
              boxShadow: "0 4px 14px rgba(244,67,54,0.35)",
            }),
          }}
        >
          {confirmLabel}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
